// lib/logger.mjs のブラウザ代替（監査ログ）。ファイル書き込みは無く、直近ログをメモリに保持して
// DevTools コンソールへ流すだけ（サーバ/ファイルへ機密を出さない方針＝計画書§16.4 と整合）。
const RING = [];
const MAX = 500;

export function auditLog(op, detail = {}) {
    const entry = { ts: new Date().toISOString(), op, ...detail };
    RING.push(entry);
    if (RING.length > MAX) RING.shift();
    try {
        // キー値等の機密は lib 側が detail に含めない設計。ここでも values は素通しにしない安全側で op のみ INFO。
        console.debug('[audit]', op, detail);
    } catch {
        /* noop */
    }
}

export function recentAuditLog() {
    return [...RING];
}
